// Nền Spine theo màn (ART_PLAN §2.5): mỗi màn có tranh nền trong client tham khảo thì dùng lại đúng
// rig và hộp của bàn dựng client, blend NORMAL với độ mờ của lớp đó (không blend kiểu CSS, TECH_BASELINE
// §11). Rig nạp lười lần đầu vào màn; màn không hiện thì không update, không vẽ.
import { Container, type Application } from 'pixi.js';
import type { SpineLayer, SpineLayerDef } from './spine/loadSpine';

interface BackdropDef {
  /** Đường dẫn rig không đuôi, dưới BASE_URL. */
  rig: string;
  layer: SpineLayerDef;
  alpha: number;
}

/** Khóa `<tab>.<screen>` (UI_SPEC §18). Màn Tu Luyện có scene riêng (cultivationScene). */
const BACKDROPS: Readonly<Record<string, BackdropDef>> = {
  // Màn 3b của client: `sbwk_bj` (kho binh khí dưới xoáy mây), opacity 0,35, zoom 1,7.
  'character.arts': {
    rig: 'assets/spine/scene/weapon-vault/weapon-vault',
    layer: { x: 0, y: 0, w: 390, h: 844, fit: 'cover', zoom: 1.7, anim: 'idle' },
    alpha: 0.35,
  },
};

export interface ScreenBackdrops {
  /** Có nền cho màn này không (để vỏ biết có cần hạt nền M0 hay không). */
  has(screenKey: string): boolean;
  show(screenKey: string | null): void;
}

export function mountScreenBackdrops(app: Application, assetBase: string): ScreenBackdrops {
  const root = new Container();
  app.stage.addChildAt(root, 0);
  const layers = new Map<string, { node: Container; layer: SpineLayer | null }>();
  let current: string | null = null;

  const tick = (): void => {
    if (!current) return;
    layers.get(current)?.layer?.update(Math.min(app.ticker.deltaMS / 1000, 0.1));
  };
  app.ticker.add(tick);

  const ensure = (key: string, def: BackdropDef): Container => {
    let entry = layers.get(key);
    if (!entry) {
      const node = new Container();
      node.alpha = def.alpha;
      root.addChild(node);
      entry = { node, layer: null };
      layers.set(key, entry);
      const slot = entry;
      void import('./spine/loadSpine')
        .then(async ({ loadSkeleton, placeSpine }) => {
          slot.layer = placeSpine(await loadSkeleton(`${assetBase}${def.rig}`), def.layer);
          node.addChild(slot.layer.node);
        })
        .catch((e: unknown) => console.warn('backdrop', key, e));
    }
    return entry.node;
  };

  return {
    has: (key) => key in BACKDROPS,
    show(key) {
      current = key && key in BACKDROPS ? key : null;
      for (const [k, e] of layers) e.node.visible = k === current;
      if (current) ensure(current, BACKDROPS[current]!).visible = true;
    },
  };
}
